import { fetchFilter } from "../network/LineHaulNetworkAPI";

export const LineHaulFilterReducer = (state, action) => {
    switch (action.type) {
        case "SELECT_SPLIT":
            let currentSelection = action.Split
            if (currentSelection.length > 2) {
                currentSelection = currentSelection.slice(1, currentSelection.length)
            }
            return {...state, Split: currentSelection,
                PackageSize: currentSelection.includes("PackageSize") ? state.PackageSize: [],
                EAD: currentSelection.includes("EAD") ? state.EAD: [],
                Cycle: currentSelection.includes("Cycle") ? state.Cycle: [],
                Cluster: currentSelection.includes("Cluster") ? state.Cluster: [],
                OtherAttributes: currentSelection.includes("OtherAttributes") ? state.OtherAttributes: []
            }
        case "SELECT_PACKAGE_SIZE":
            return  {...state, PackageSize: action.PackageSize}
        case "SELECT_EAD":
            return  {...state, EAD: action.EAD}
        case "SELECT_CYCLE":
            return  {...state, Cycle: action.Cycle}
        case "SELECT_CLUSTER":
            return  {...state, Cluster: action.Cluster}
        case "SELECT_OTHER_ATTRIBUTES":
            return  {...state, OtherAttributes: action.OtherAttributes}
        case "REMOVE_FILTER":
        {
            const {key, value} = action.data
            state[key] = state[key].filter(item => item !== value)
            const newItem = state[key].filter(item => item !== value)
            return {
                ...state,
                [key] : newItem
            }
        }
        case "LOAD_VIEW":
            const {dispatcher} = action.data
            fetchFilter(dispatcher)
            return state
        case "RECEIVE_FILTER_FOR_LINEHAUL":
            return {...state, Filters: {...state.Filters, ...action.data}}
        case "RECEIVE_CYCLE":
            return {...state, Filters: {...state.Filters, Cycle: action.data}}
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/linehaul/reducers/LineHaulFilterReducer.js